import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-catalogo-lista-default',
  templateUrl: './catalogo-lista-default.component.html',
  styleUrls: ['./catalogo-lista-default.component.scss']
})
export class CatalogoListaDefaultComponent implements OnInit {
  @Input() public addText: string;
  @Input() public addPermission: boolean;
  @Output() public addNew:EventEmitter<boolean> = new EventEmitter;
  mostrarListado: boolean;
  constructor() { }

  ngOnInit() {
  }

  add() {
    this.addNew.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/partials/catalogo-lista-default/catalogo-lista-default.component.ts